import Card from "../../../shared/Card/Card";
import "./style.css";   
import { useTranslation } from "react-i18next";
const PatientSummaryHeader = ({ data }) => {
  const {patientData} = data || {};
  const { t,i18n } = useTranslation();
  const { name, age, gender, id } = patientData || {};
  const cardClassName = "d-flex flex-column align-items-start justify-content-center gap-1 section rounded-0";
  return (
    <div dir={i18n.language === "ar" ? "rtl" : "ltr"} className="bg-white header-container">
      <Card title={t("patient-name")} value={name} className={cardClassName} />
      <Card title={t("age-gender")} value={`${age} ${t("years")} / ${gender}`} className={cardClassName} />
      <Card title={t("internal-case-id")} value={id} className={cardClassName} />
    </div>
  );    
};

export default PatientSummaryHeader;

